export const MAX_AUDIO_UPLOAD_SIZE_BYTES = 3145728;  // 3MB
export const MAX_IMAGE_UPLOAD_SIZE_BYTES = 2097152;  // 2MB
export const MAX_VIDEO_UPLOAD_SIZE_BYTES = 26214400;  // 25MB